import React from 'react';
import { ShoppingCart } from 'lucide-react';
interface BuyButtonProps {
  text?: string;
  className?: string;
}
export const BuyButton: React.FC<BuyButtonProps> = ({
  text = 'Quiero asegurar mi cupo',
  className = ''
}) => {
  return <a href="https://checkout.ebookpoint.shop/cart/59674556596305:1" className={`inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#d4a017] to-[#f0b429] text-[#0b1622] font-bold text-lg md:text-xl py-4 px-8 rounded-full hover:scale-105 transition-transform shadow-[0_0_20px_rgba(240,180,41,0.4)] w-full md:w-auto text-center ${className}`} data-id="element-242">
      <ShoppingCart className="w-6 h-6 flex-shrink-0" data-id="element-243" />
      <span data-id="element-244">{text}</span>
    </a>;
};